import React from "react";
import {css, Theme} from "@emotion/react";

import {calculateRemSize as crs, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    place: number;
    text: string;
}

export const RankingCreationStep = (props: IProps) => {
    const {place, text} = props;
    return (
        <li css={rankingCreationStep}>
            <Text as="span" variant="headline_1" css={placeStyle}>
                {place}
            </Text>
            <Text variant="body_copy_1">{text}</Text>
        </li>
    );
};

// Styles
const rankingCreationStep = css`
    display: flex;
    gap: ${crs(3)};
`;

const placeStyle = (theme: Theme) => css`
    height: ${crs(7)};
    width: ${crs(7)};
    background-color: ${theme.colors.primary};
    border-radius: 50%;
    flex: 0 0 ${crs(7)};
    display: flex;
    align-items: center;
    justify-content: center;

    ${onDesktop(css`
        height: ${crs(8)};
        width: ${crs(8)};
        flex: 0 0 ${crs(8)};
    `)}
`;
